import { toastr } from 'react-redux-toastr';
import { HCM_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_POSITIONS,
  FLAG_GETTING_POSITIONS,
  GET_POSITIONS,
} from '../types/hcm';

export const flagGettingPositions = (payload) => ({
  type: FLAG_GETTING_POSITIONS,
  payload,
});

export const getPositions = () => async (dispatch) => {
  try {
    dispatch(flagGettingPositions(true));

    const url = `${HCM_ENDPOINT}/position`;

    const response = await fetch(url, {
      ...DEFAULT_GET_CONFIG,
    });

    await isErrorResponse(response, null, dispatch);

    const positions = await response.json();

    dispatch({
      type: GET_POSITIONS,
      payload: positions,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingPositions(false));
  }
};

export const clearPositions = () => ({
  type: CLEAR_POSITIONS,
});
